/**
 * Constants for the Institution Dashboard
 * CAMEL component configuration, rating scales, and category mappings
 *
 * Re-exports shared constants from centralized location for backward compatibility.
 */

// Re-export CAMEL constants from shared location
export {
  camelLabels,
  orderedCamelCodes,
  radarOrderedCodes,
  categoryMapping,
} from '../../constants/camelConstants';

export type { CAMELCode, CAMELLabelConfig, CAMELComponent } from '../../constants/camelConstants';

// Re-export rating scale and thresholds from shared location
export { ratingScale, ratingThresholds } from '../../utils/ratingColors';

/**
 * Quarter ending months (for highlighting official rating periods)
 */
export const quarterEndMonths = [3, 6, 9, 12]; // March, June, September, December

/**
 * Spanish month abbreviations
 */
export const monthNames = [
  'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
  'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
];

/**
 * Default number of history periods to show in timeline
 */
export const DEFAULT_HISTORY_PERIODS = 13; // 13 months

/**
 * Default number of reports to show
 */
export const DEFAULT_REPORTS_LIMIT = 5;
